import parseJwt from '../utils/parseJwt';

interface ITokens {
  new_auth: string;
  offline_auth: string;
}
interface AuthState {
  token: string;
  offline_token: string;
}

const DEBOUNCE_DURATION = 2000; //2 seconds

const _checkLogoutLock = () => {
  const logoutLock = localStorage.getItem('logout.lock');
  return Number(logoutLock) > Date.now();
};

const _setAuthToken = (token: string) => {
  if (typeof token !== 'undefined' && token !== null && token !== '' && token !== 'undefined' && !_checkLogoutLock()) {
    localStorage.setItem('timocco.auth', token);
  } else {
    console.error('!!token is undefined!!', token);
  }
};

class AuthService {
  static authTokenExists() {
    return localStorage.getItem('timocco.auth') !== null;
  }
  /**
   * Pulls auth and offline tokens from HTTP response and stores them in local storage
   * @param tokens pass response object from any HTTP response from backend to extract auth and offline tokens
   */
  static storeTokens(tokens: ITokens) {
    _setAuthToken(tokens.new_auth);

    if (tokens.offline_auth) {
      localStorage.setItem('timocco.offline', tokens.offline_auth);
    }
  }
  /**
   * Pulls auth and offline tokens from redux state and stores them in local storage
   * @param state pass user state to extract auth and offline tokens
   */
  static storeAuthState(state: AuthState) {
    _setAuthToken(state && state.token);
    localStorage.setItem('timocco.offline', state && state.offline_token);
  }
  /**
   * Get auth and offline tokens from local storage
   */
  static getAuth() {
    return {
      token: localStorage.getItem('timocco.auth'),
      offline_token: localStorage.getItem('timocco.offline'),
    };
  }
  /**
   * Set auth token explicitly
   * @param token auth token
   */
  static setAuthToken(token: string) {
    _setAuthToken(token);
  }
  /**
   * Get Auth token from local storage
   */
  static getAuthToken() {
    const authToken = localStorage.getItem('timocco.auth');

    if (authToken === 'undefined') {
      localStorage.removeItem('timocco.auth');
      return;
    }

    return localStorage.getItem('timocco.auth');
  }
  /**
   * Get timestamp validated offline token
   * @returns valid offline token or null if absent or expired
   */
  static getOfflineToken() {
    const _offlineTokenRaw = localStorage.getItem('timocco.offline');
    if (_offlineTokenRaw === null || _offlineTokenRaw === '') {
      return null;
    }
    const _offlineToken = parseJwt(_offlineTokenRaw);
    const current_timestamp = Math.floor(Date.now() / 1000);
    return _offlineToken.exp > current_timestamp ? _offlineTokenRaw : null;
  }
  /**
   * Remove auth from local storage
   */
  static clearAuth() {
    localStorage.setItem('logout.lock', String(Date.now() + DEBOUNCE_DURATION));
    localStorage.removeItem('timocco.auth');
  }
}

export default AuthService;
